import React from 'react';
import './data-row.scss';

interface DataRowProps {
    title: string;
}

const DataRow: React.FC<DataRowProps> = (props) => {
    const {title = '', children} = props;
    const _cType = typeof children;

    return (
        <div className="data-row-c">
            <div className="title">{title}</div>
            {(_cType === 'string' || _cType === 'number') && <div className="desc">{children}</div>}
            {_cType === 'object' && children}
        </div>
    );
};

export default DataRow;
